import { Box, Divider, Stack, Typography, useTheme } from "@mui/material";
import merge from "lodash/merge";

import { FAQAccordion, originalSkin } from "../../../../Components/FAQ/FAQAccordion";
import { type K8sUpsellMode } from "../Fsk8sUpsell";
import { KUBERNETES_LENS_FAQS, PERFECTSCALE_FAQS } from "./content";

interface FaqProps {
  mode: K8sUpsellMode;
}

const Faq = ({ mode }: FaqProps) => {
  const theme = useTheme();

  const faqAccordionProps = merge(originalSkin(theme), {
    AccordionProps: {
      sx: {
        backgroundColor: "transparent",
      },
    },
    QuestionTypographyProps: {
      sx: {
        fontWeight: 400,
      },
    },
  });

  return (
    <Box>
      <Stack spacing={2}>
        <Typography variant="h3">Frequently asked questions</Typography>
        <Box>
          <Divider />
          <FAQAccordion faqs={mode === "lens" ? KUBERNETES_LENS_FAQS : PERFECTSCALE_FAQS} props={faqAccordionProps} />
        </Box>
      </Stack>
    </Box>
  );
};

export default Faq;
